<!--
@Author: DKing
@Desc: 解决方案-通用方案
@Date: 2021-04-22
-->
<template>
  <div>
    <div class="banner-box">
      <div class="min-width-pc">
        <p class="title">场景化<br>灵活用工服务平台</p>
        <p class="text">根据行业及企业用工场景，提供高效的产品解决方案，<br> 精准打击行业痛点</p>
        <span class="btnFullColor" @click="jumpPage">立即咨询</span>
      </div>
    </div>

    <div class="min-width-pc">
      <div class="title-txt">灵活用工模式痛点</div>
      <div class="tab-box">
        <div class="tabs">
          <span class="tab" :class="activeType == 'one' && 'active'" @click="clickTab('one')">企业</span>
          <span class="tab" :class="activeType == 'two' && 'active'" @click="clickTab('two')">新个体</span>
          <p class="slider"></p>

          <div class="tab-content">
            <div class="item" v-for="(item, index) in productList" :key="index">
              <img :src="item.imgUrl" alt="">
              <span class="title">{{item.title}}</span>
              <span>{{item.text}}</span>
            </div>
          </div>
        </div>

      </div>

      <div class="title-txt">灵活用工解决方案</div>
      <div class="product-container">
        <div class="item">
          <img style="margin-right:90px;" class="product-img" src="./../../../static/pc/解决方案/img_solution_12.png" alt="">

          <div class="product-text">
            <p class="title">
              「企业+平台+新个体」 <br> 新经济合作模式
            </p>
            <p class="text">
              根据行业及客户真实场景制定专属高效的产品解决方案
            </p>
          </div>
        </div>

        <div class="item">
          <div class="product-text">
            <p class="title">
              「自然人」 <br> 众包模式
            </p>
            <p class="text">
              根据行业及客户真实场景制定专属高效的产品解决方案
            </p>
          </div>

          <img style="margin-left:27px;" class="product-img" src="./../../../static/pc/解决方案/img_solution_13.png" alt="">
        </div>
      </div>

      <div class="title-txt">慧用工方案优势</div>
      <div class="case-box">
        <div class="case-item">
          <img src="./../../../static/pc/解决方案/icon_solution_31@2x.png" alt="">
          <div class="text-box">
            <p class="title">合法合规</p>
            <p>
              严格遵循国家法律法规，按规代征个人税收；平台业务链条完整合规，四流一致
            </p>
          </div>
        </div>
        <div class="case-item">
          <img src="./../../../static/pc/解决方案/icon_solution_32@2x.png" alt="">
          <div class="text-box">
            <p class="title">成本优化</p>
            <p>
              降低企业运营管理成本，降低企业用工成本，提高个人收入
            </p>
          </div>
        </div>
        <div class="case-item">
          <img src="./../../../static/pc/解决方案/icon_solution_33@2x.png" alt="">
          <div class="text-box">
            <p class="title">简单高效</p>
            <p>
              智能结算saas系统，全程线上办理，操作简单，提高企业管理效率，降低人工出错概率，降低HR及财务工作量
            </p>
          </div>
        </div>
        <div class="case-item">
          <img src="./../../../static/pc/解决方案/icon_solution_34@2x.png" alt="">
          <div class="text-box">
            <p class="title">资金安全</p>
            <p>
              我们与招商及网商银行建立合作，共管账户、专款专用、秒级结算到账（可结算至个人银行账户、微信钱包余额、支付宝账户）保障客户的资金安全
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- 弹窗form -->
    <pc-form-dialog :source='source'><span class="pc-form-text">慧用工｜致力于助力每一个优秀的公司</span></pc-form-dialog>
    <!-- 底部悬浮框 -->
    <pc-suspension-dialog :source="sourceF"></pc-suspension-dialog>
  </div>
</template>

<script type="text/javascript">
import pcFormDialog from '../../components/pcFormDialog.vue'
import pcSuspensionDialog from "../../components/pcSuspensionDialog";
export default {
  name: "solution-normal",
  data() {
    return {
      
      productList:[
        {imgUrl:'./../../../static/pc/解决方案/Solution_icon_qiye_1@2x.png', title:'税务风险高', text:'企业给灵活用工人员结算，无合规发票入账'},
        {imgUrl:'./../../../static/pc/解决方案/Solution_icon_qiye_2@2x.png', title:'用工风险高', text:'用工隶属关系不明确，社保补缴、劳动仲裁风险高'},
        {imgUrl:'./../../../static/pc/解决方案/Solution_icon_qiye_3@2x.png', title:'用工管理难', text:'跨地区信息采集、薪酬管理、签约管理等难度大'},
        {imgUrl:'./../../../static/pc/解决方案/Solution_icon_qiye_4@2x.png', title:'结算时效差', text:'个人对结算时效要求高，但资金体量大，效率低'}
      ],
      activeType: 'one',
      source: '',
      sourceF: "",

    }
  },

  components: {
    "pc-form-dialog": pcFormDialog,
    "pc-suspension-dialog": pcSuspensionDialog
  },
  
  created() {
    // source来源：：
    let hash = window.location.hash;
    this.source = hash.indexOf('source') > 0 ? hash.substring(hash.indexOf('source')) + '&pageFrom=jjfa_tyfa' : '&pageFrom=jjfa_tyfa';
    this.sourceF = this.source + "_f";
  },

  methods: {
    clickTab(type){
      this.activeType = type;
      if(type == 'one'){
        this.productList = [
          {imgUrl:'./../../../static/pc/解决方案/Solution_icon_qiye_1@2x.png', title:'税务风险高', text:'企业给灵活用工人员结算，无合规发票入账'},
          {imgUrl:'./../../../static/pc/解决方案/Solution_icon_qiye_2@2x.png', title:'用工风险高', text:'用工隶属关系不明确，社保补缴、劳动仲裁风险高'},
          {imgUrl:'./../../../static/pc/解决方案/Solution_icon_qiye_3@2x.png', title:'用工管理难', text:'跨地区信息采集、薪酬管理、签约管理等难度大'},
          {imgUrl:'./../../../static/pc/解决方案/Solution_icon_qiye_4@2x.png', title:'结算时效差', text:'个人对结算时效要求高，但资金体量大，效率低'}
        ]

      } else if(type == 'two'){
        this.productList = [
          {imgUrl:'./../../../static/pc/解决方案/Solution_icon_geren_1@2x.png', title:'个人税负高', text:'个人按劳务报酬所得20-40%缴纳个税，税负重'},
          {imgUrl:'./../../../static/pc/解决方案/Solution_icon_geren_2@2x.png', title:'年底汇算清缴', text:'个人取得劳务所得，年底汇算清缴，可能涉及补税'},
          {imgUrl:'./../../../static/pc/解决方案/Solution_icon_geren_3@2x.png', title:'个人扣税困难', text:'个人纳税意识不高，认为到手金额应该为约定金额'},
          {imgUrl:'./../../../static/pc/解决方案/Solution_icon_geren_4@2x.png', title:'开票难度大', text:'企业要求个人提供发票，但个人取得发票难度大'}
        ]
      }
    },

    jumpPage(){
      eventBus.$emit("pcOperaDiaLog", true);
    },
  }
}
</script>

<style lang="scss" scoped>
.banner-box{
  background:url('./../../../static/pc/产品服务/banner_solution_1.png') no-repeat;
  background-size: cover;
  background-color: #111010;
  .text{
    text-align: left;
    color:#fff;
    line-height: 26px;
    margin-bottom:28px;
  }
}
.title-txt{
  margin-top:88px;
}
.tab-box{
  margin-top: 80px;
  .tabs{
    color: rgba(23, 30, 46, 100);
    font-size: 24px;
    text-align: center;
    // font-family: AlibabaPuHuiTi-Medium;
    position: relative;
    top:2px;
    .tab{
      display: inline-block;
      width: 180px;
      height: 44px;
      border-bottom: 4px solid rgba(25, 133, 255,0);
      font-weight: bold;
      cursor: pointer;
    }

    .active{
      color:rgb(25, 133, 255);
      border-bottom: 4px solid rgba(25, 133, 255,1);
      -webkit-transition: all 0.8s;
      -moz-transition: all 0.8s;
      -ms-transition: all 0.8s;
      -o-transition: all 0.8s;
      transition: all 0.8s;
    }

    .tab-content{
      margin-top:57px;
      display: flex;
      justify-content: space-around;
      .item{
        width:285px;
        height: 348px;
        text-align: center;
        background-color: rgba(255, 255, 255, 1);
        box-shadow: 0px 20px 60px -20px rgba(0, 0, 0, 0.1);
        color: #403F3F;
        font-size: 16px;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        padding:0 24px;
        img{
          width:100px;
          margin-bottom:41px;
        }
        .title{
          color: rgba(64, 63, 63, 100);
          font-size: 18px;
          // font-family: AlibabaPuHuiTi-Medium;
          margin-bottom:16px;
          font-weight: bold;
        }
        &:hover{
          background-color: rgba(255, 255, 255, 1);
          box-shadow: 0px 20px 20px 0px rgba(16, 15, 15, 0.09);
          position: relative;
          top:-5px;
        }
      }
    }
  }
  
  .slider{
    width: 100%;
    height: 1px;
    border-radius: 24px;
    background-color: rgba(207, 207, 207, 1);
    box-shadow: 0px 20px 60px 0px rgba(0, 0, 0, 0.1);
    margin-bottom:57px;
  }
}

.product-container{
  margin-top: 96px;
  .item{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 80px;
    .product-text{
      width:495px;
      text-align: left;
      .title{
        color: rgba(64, 63, 63, 100);
        font-size: 24px;
        // font-family: AlibabaPuHuiTi-Medium;
        margin-bottom: 20px;
        font-weight: bold;
        position: relative;
        padding-bottom: 22px;
        &::after{
          content: '';
          width: 24px;
          height: 4px;
          display: block;
          border-radius: 16px;
          position: absolute;
          bottom: 0;
          background-color: rgba(25, 133, 255, 1);
        }
      }
      .text{
        line-height: 36px;
        color: rgba(64, 63, 63, 100);
        font-size: 14px;
      }
    }

    .product-img{
      width: 805px;
    }

  }
}

.case-box{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 77px;
  margin-bottom: 93px;
  .case-item{
    width:590px;
    height: 208px;
    display: inline-flex;
    padding:30px 20px 0 30px;
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 0px 20px 60px -20px rgba(0, 0, 0, 0.1);
    margin-bottom: 20px;
    box-sizing: border-box;
    &:hover{
      position: relative;
      top:-5px;
      background-color: rgba(255, 255, 255, 1);
      box-shadow: 0px 20px 20px 0px rgba(16, 15, 15, 0.09);
    }
    img{
      width: 50px;
      height: 50px;
      vertical-align: top;
      margin-right:30px;
    }
    .text-box{
      line-height: 32px;
      color: rgba(64, 63, 63, 100);
      font-size: 18px;
      text-align: left;
      .title{
        color: rgba(16, 15, 15, 100);
        font-size: 24px;
        text-align: center;
        // font-family: AlibabaPuHuiTi-Medium;
        font-weight: bold;
        text-align: left;
        margin-bottom: 20px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/pc/solution_normal.vue